import { render } from "./QuanLyDonHang.vue?vue&type=template&id=300193b4&scoped=true"
import script from "./QuanLyDonHang.vue?vue&type=script&lang=js"
export * from "./QuanLyDonHang.vue?vue&type=script&lang=js"

import "./QuanLyDonHang.vue?vue&type=style&index=0&id=300193b4&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-300193b4"]])

export default __exports__